import React from "react";
import { Box, Typography, FormControl, FormLabel, Select, MenuItem } from "@mui/material";
import HPInput from "../../../common/Input";

interface EmphasisOption {
  value: string;
  label: string;
}

interface CenterValueSectionProps {
  emphasis: string;
  emphasisDisplayFormat: "percentage_title" | "percentage_custom";
  emphasisCustomText: string;
  emphasisOptions: EmphasisOption[];
  onEmphasisChange: (value: string) => void;
  onEmphasisDisplayFormatChange: (
    value: "percentage_title" | "percentage_custom",
  ) => void;
  onEmphasisCustomTextChange: (value: string) => void;
}

const CenterValueSection: React.FC<CenterValueSectionProps> = ({
  emphasis,
  emphasisDisplayFormat,
  emphasisCustomText,
  emphasisOptions,
  onEmphasisChange,
  onEmphasisDisplayFormatChange,
  onEmphasisCustomTextChange,
}) => {
  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 700 }}>
        Center Value Configuration
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <FormControl fullWidth size="small">
          <FormLabel className="text-[12px] text-[#262626]">
            Emphasis
          </FormLabel>
          <Select
            value={emphasis}
            onChange={(e) => onEmphasisChange(e.target.value)}
          >
            {emphasisOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {emphasis !== "none" && (
          <>
            <FormControl fullWidth size="small">
              <FormLabel className="text-[12px] text-[#262626]">
                Emphasis Display Format
              </FormLabel>
              <Select
                value={emphasisDisplayFormat}
                onChange={(e) =>
                  onEmphasisDisplayFormatChange(
                    e.target.value as "percentage_title" | "percentage_custom",
                  )
                }
              >
                <MenuItem value="percentage_title">
                  Percentage + Title
                </MenuItem>
                <MenuItem value="percentage_custom">
                  Percentage + Custom Text
                </MenuItem>
              </Select>
            </FormControl>

            {emphasisDisplayFormat === "percentage_custom" && (
              <HPInput
                label="Custom Text"
                value={emphasisCustomText}
                onChange={(e) => onEmphasisCustomTextChange(e.target.value)}
                placeholder="Enter custom text"
              />
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default CenterValueSection;
